module.exports = __webpack_public_path__ + "img/3fd97340d974eb0b6218331544fb7f98.6a5d2f8c.png";